import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
  FormDescription,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

const IndividualPersonalDetailsForm: FC<FormProps> = props => {
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    toggleShowByName,
    toggleShowByVisualName,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(
    props.fetchedData,
    config({ countries: dropdownOptions.countries, countryTelephoneCodes: dropdownOptions.countryTelephoneCodes }),
    submitForm
  )

  useEffect(() => {
    toggleShowByName('otherTitle', parseInt(formData.title.value) === 4)
  },[formData.title.value])

  useEffect(() => {
    toggleShowByVisualName('previousAddressText', parseInt(formData.currentAddressLivingYears.value) < 3 ? 'true' : 'false')
    toggleShowByName('previousStreet', parseInt(formData.currentAddressLivingYears.value) < 3)
    toggleShowByName('previousTown', parseInt(formData.currentAddressLivingYears.value) < 3)
    toggleShowByName('previousPostcode', parseInt(formData.currentAddressLivingYears.value) < 3)
    toggleShowByName('previousCountry', parseInt(formData.currentAddressLivingYears.value) < 3)
  },[formData.currentAddressLivingYears.value])

  useEffect(() => {
    toggleShowByName('employerOccupation', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('companyName', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('typeOfBusiness', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('companyAddress', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('companyCity', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('companyPostCode', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('companyCountry', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByVisualName(
      'employedTimeLabel',
      (parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2) ? 'true' : 'false'
    )
    toggleShowByName('currentEmploymentDurationYears', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
    toggleShowByName('currentEmploymentDurationMonths', parseInt(formData.employmentStatus.value) === 0 || parseInt(formData.employmentStatus.value) === 2)
  },[formData.employmentStatus.value])

  useEffect(() => {
    toggleShowByVisualName('previousEmployerText', (parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0) ? 'true' : 'false')
    toggleShowByName('previousEmployerOccupation', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)
    toggleShowByName('previousEmployerName', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)
    toggleShowByName('previousEmployerType', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)
    toggleShowByName('previousEmployerAddress', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)
    toggleShowByName('previousEmployerTown', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)
    toggleShowByName('previousEmployerPostcode', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)
    toggleShowByName('previousEmployerCountry', parseInt(formData.currentEmploymentDurationMonths.value) < 6 && parseInt(formData.currentEmploymentDurationYears.value) === 0)

  },[formData.currentEmploymentDurationMonths.value, formData.currentEmploymentDurationYears.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t(
            'onboarding.forms.IndividualAccount.PersonalDetailsForm.title'
          )}
        </FormTitle>
        <FormDescription>
          {t('onboarding.forms.IndividualAccount.PersonalDetailsForm.description')}
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualPersonalDetailsForm
